// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gS6eY","top":"styles_top__2Y8dg"};